import React from "react"
import { cn } from "../../../utils/utils"
import Markdown from "markdown-to-jsx"
import GalleryLink from "../../chat/SlickAIGalleryLink"
import { HeadingBlock } from "./types"
import { linkifyUrls } from "@/components/chat/SlickAIMessage"

export const HeadingRenderer = ({
  block,
  messageId,
  linkOverride,
}: {
  block: HeadingBlock
  messageId: string
  linkOverride?: React.ComponentType<{
    href: string
    children: React.ReactNode
  }>
}) => {
  const HeadingTag = `h${block.level ?? 1}` as keyof JSX.IntrinsicElements
  const LinkComponent = linkOverride || GalleryLink

  return (
    // @ts-ignore
    <HeadingTag
      className={cn(
        "mb-2 mt-3 font-semibold",
        block.level === 1 && "text-2xl",
        block.level === 2 && "text-xl",
        block.level === 3 && "text-lg",
        block.level >= 4 && "text-base",
      )}
    >
      <Markdown
        options={{
          overrides: {
            a: {
              component: LinkComponent,
              props: linkOverride ? {} : { messageId },
            },
          },
        }}
      >
        {linkifyUrls(block.text)}
      </Markdown>
    </HeadingTag>
  )
}
